import Heading from 'components/Heading'
import React from 'react'

import bayOverviewIcon from './Images/bay-over-view-icon.png'
import bayOverviewPage from './Images/bay-over-view-page.png'

const BayOverview = () => (
  <div>
    <Heading isDark level={2}>
      Bay Overview
    </Heading>

    <p>
      The Bay Overview feature provides a graphical representation of container
      locations across the vessel&apos;s bays. It enables crews to quickly
      identify container positions, monitor cargo operations, and review loading
      and discharge plans for the current port call.
    </p>

    <img src={bayOverviewIcon} />

    <Heading isDark level={3}>
      Loading & discharge overview:
    </Heading>
    <p>
      Use the tabs in bottom to switch between discharge and loading overview
      for this port call.
    </p>

    <p>Use the navigation button to switch between bay sets.</p>

    <img src={bayOverviewPage} />

    <p>
      Each container cell is colour-coded based on its operational status.
      Special cargo types, including DG, Reefer, and OOG, similar to the display
      in the Cargo Plan screen.
    </p>
  </div>
)

export default BayOverview
